import React from "react";
import logo1 from "../../images/logo1.png";
import logo2 from "../../images/logo2.png";
import logo3 from "../../images/logo3.png";
import logo4 from "../../images/logo4.png";
import { Link } from "react-router-dom";
const logos = [
  {
    image: logo1,
    title: "Americans4Hindus PAC - Political Action Committee",
    pageLink: "/americans4hindus-pac-political-action-committee",
    membershipLink: "https://secure.anedot.com/a4h/donate",
    volunteerLink: "/pac-volunteer",
  },
  {
    image: logo2,
    title: "Americans4Hindus - 501(C)(3) - Non Profit Organization",
    pageLink: "/americans4hindus-501c3-nonprofit",
    membershipLink: "https://givebutter.com/DONATEA4HNPO",
    volunteerLink: "/5o1c3-volunteer",
  },
  {
    image: logo4,
    title: "Americans4Hindus - 501(C)(4) DAC (Dharma Action Council)",
    pageLink: "/dharma-action-council",
    membershipLink: "",
    volunteerLink: "/5o1c4-volunteer",
  },
  {
    image: logo3,
    title: "Festival of Globe - 501(C)(3) Non Profit Organization",
    pageLink: "/festival-of-globe",
    membershipLink: "https://givebutter.com/Nnf9Vr",
    volunteerLink: "/fog-volunteer",
  },
];

function MembershipVolunteer() {
  return (
    <>
      <style>{`
        .membership-volunteer-page {
          min-height: 70vh;
        }

        .membership-volunteer-title {
          text-align: center;
          font-size:48px;
          font-weight:900;
          width: 100%;
          
          margin: 0 auto;
          text-transform: uppercase;
        }
.membership-logo-title{
  text-align:center;
  font-size:28px;
  font-weight:900;
  color:#1a2a5a;
  margin-bottom:22px;
  line-height:1.25;
  text-transform:none;
}
.dac-description {
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: #444;
  margin-top: 8px;
  line-height: 1.4;
}
        .section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}

        .membership-logo-grid {
  width: min(1100px, calc(100% - 32px));
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 60px;
  align-items: center;
  justify-items: center;
}

        .membership-logo-card {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

        .logo-link{
  display:block;
  text-decoration:none;
}

.membership-logo-card img{
  width:520px;
  height:420px;
  object-fit:contain;
  background:#fff;
  padding:20px;
  box-sizing:border-box;

  border:4px solid transparent;
  border-radius:30px;

  background-image:
    linear-gradient(#fff,#fff),
    linear-gradient(135deg,#0b3d7a,#d4af37,#ff8c1a,#0b3d7a);

  background-origin:border-box;
  background-clip:padding-box,border-box;

  box-shadow:
    0 12px 30px rgba(0,0,0,.22);

  transition:all .35s ease;
}

.logo-link:hover img{
  transform:translateY(-8px) scale(1.04);

  box-shadow:
    0 18px 40px rgba(0,0,0,.28),
    0 0 30px rgba(212,175,55,.45);

  border-radius:36px;
}

.logo-link:active img{
  transform:scale(.98);
}

        .membership-buttons{
  display:flex;
  justify-content:center;
  gap:14px;
  margin-top:22px;
  flex-wrap:wrap;
}

.membership-btn{
  position: relative;
  min-width: 220px;
  padding: 18px 40px;
  border: none;
  border-radius: 50px;
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .8px;
  cursor: pointer;
  overflow: hidden;

  transform: translateY(0);
  transition: all .18s ease;

  box-shadow:
    0 8px 0 rgba(0,0,0,.28),
    0 14px 24px rgba(0,0,0,.22),
    inset 0 2px 2px rgba(255,255,255,.35),
    inset 0 -3px 5px rgba(0,0,0,.18);
}

/* Top glossy shine */
.membership-btn::before{
  content:"";
  position:absolute;
  top:2px;
  left:8%;
  width:84%;
  height:45%;
  border-radius:40px;
  background:rgba(255,255,255,.28);
  filter:blur(.5px);
}

/* Moving light effect */
.membership-btn::after{
  content:"";
  position:absolute;
  top:0;
  left:-120%;
  width:50%;
  height:100%;
  background:linear-gradient(
    120deg,
    transparent,
    rgba(255,255,255,.45),
    transparent
  );
  transition:left .55s ease;
}

.membership-btn:hover::after{
  left:140%;
}

.membership-btn:hover{
  transform:translateY(-3px);
}

.membership-btn:active{
  transform:translateY(6px);
  box-shadow:
    0 2px 0 rgba(0,0,0,.25),
    0 5px 10px rgba(0,0,0,.18),
    inset 0 2px 4px rgba(0,0,0,.18);
}

/* Orange Membership Button */
.membership-btn.membership{
  background:linear-gradient(
    to bottom,
    #ffb347 0%,
    #ff8c1a 45%,
    #ff7000 70%,
    #d85c00 100%
  );
}

/* Navy Volunteer Button */
.membership-btn.volunteer{
  background:linear-gradient(
    to bottom,
    #3d73b5 0%,
    #1f5aa5 45%,
    #0b3d7a 70%,
    #062c59 100%
  );
}

.membership-btn.membership:hover{
  filter:brightness(1.08);
}

.membership-btn.volunteer:hover{
  filter:brightness(1.08);
}

@media (max-width:640px){

.membership-volunteer-page{
    padding-top:15px;
}

.block.color-scheme-4{
    padding:20px 0;
}

.membership-volunteer-title{
    font-size:clamp(18px, 5vw, 22px);
    line-height:1.2;
    white-space:nowrap;
    text-align:center;
    letter-spacing:0.3px;
}

.section-divider{
    margin:20px auto 25px;
}

.section-divider span{
    font-size:18px;
}

.membership-logo-grid{
    width:calc(100% - 20px);
    gap:24px;
    padding:0 10px;
}

.membership-logo-card{
    width:100%;
    max-width:280px;
    margin:0 auto;
}

.membership-logo-title{
    font-size:16px;
    line-height:1.35;
    margin-bottom:12px;
    padding:0 8px;
}

.membership-logo-card img{
    width:100%;
    max-width:260px;
    height:auto;
    padding:10px;
    border-radius:16px;
    box-shadow:
      0 0 0 3px #c1931d,
      0 5px 14px rgba(0,0,0,.18);
}

.membership-buttons{
    width:100%;
    max-width:240px;
    gap:10px;
    margin-top:14px;
}

.membership-buttons a{
    width:100%;
}

.membership-btn{
    width:100%;
    min-width:unset;
    padding:10px 16px;
    font-size:13px;
    border-radius:40px;

    box-shadow:
      0 4px 0 rgba(0,0,0,.28),
      0 6px 12px rgba(0,0,0,.18);
}
.dac-description {
    font-size: 11px;
    line-height: 1.35;
    margin-top: 5px;
  }
}
      `}</style>

      <section className="membership-volunteer-page">
        <div className="block color-scheme-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="container text-center">
                  <h1 className="head-title membership-volunteer-title">
                    MEMBERSHIP &amp; VOLUNTEERING
                  </h1>
                  <div className="section-divider">
  <span>✦ ✦ ✦</span>
</div> 
                </div>
              </div>
            </div>
          </div>

          <div className="membership-logo-grid">
  {logos.map((logo) => (
    <div className="membership-logo-card" key={logo.title}>
  <h2 className="membership-logo-title"> 
  {logo.title}

  {logo.title.includes("Dharma Action Council") && (
    <small className="dac-description">
      Americans4Hindus Dharma Action Council
Is in the process of securing status as a 501(c)(4) organization. Tax ID #41-5306681.
    </small>
  )}
</h2>

  <Link to={logo.pageLink} className="logo-link">
  <img src={logo.image} alt={logo.title} />
</Link>

      <div className="membership-buttons">
  <a
    href={logo.membershipLink}
    target="_blank"
    rel="noopener noreferrer"
  >
    <button className="membership-btn membership">
      DONATE & BECOME A MEMBER
    </button>
  </a>

  <Link to={logo.volunteerLink}>
    <button className="membership-btn volunteer">
      BECOME OUR VOLUNTEER
    </button>
  </Link>
</div>
    </div>
  ))}
</div>
        </div>
      </section>
    </>
  );
}

export default MembershipVolunteer;
